<template>
  <sa-page-layout :showModalLoading="showModalLoading" :pathResource="pathResource">
    <template slot="toolbar">
      <!-- <b-button class="float-sm-right" variant="success btn-toolbar sa-margin-right" size="sm"
        @click="onAggiungiModificaAccettazione"><b-icon icon="plus"></b-icon>Nuova Accettazione</b-button>
      <b-button variant="purple  btn-toolbar float-sm-right sa-margin-right" size="sm"
        @click="onClickNuovaAccettazioneNRE()"> <b-icon size="large" icon="folder-plus"></b-icon>Nuova Accettazione
        NRE</b-button> -->
    </template>
    <template slot="table-filter">
      <b-form style="width: 100%" @submit.prevent="submit">
        <div class="sa-form-section sa-search-box">
          <b-row style="margin-left: 0.5rem; margin-right: 0.5rem" class="sa-form-btn-filter">

            <b-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
              <label class="sa-label-data">C.F Paziente</label>
              <input class="sa-search-box-input text-upper" type="search" v-model="filtro.cfPaziente" />
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
              <div class="sa-page-search-component-input-group" style="flex: 1; min-width: 70px">
                <label class="sa-search-box-label">Data Riferimento Prenotazione</label>
                <div class="sa-page-search-component-wrapper">
                  <date-picker format="DD/MM/YYYY" class="sa-ft-date-input" value-type="timestamp"
                    v-model="filtro.dataRiferimento" type="datetime"></date-picker>
                </div>
              </div>
            </b-col>
            <!-- <b-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
              <div class="sa-page-search-component-input-group" style="flex: 1; min-width: 70px">
                <label class="sa-search-box-label">Data Prenotazione Al</label>
                <div class="sa-page-search-component-wrapper">
                  <date-picker format="DD/MM/YYYY HH:mm" value-type="timestamp" v-model="filtro.endTime"
                    type="datetime"></date-picker>
                </div>
              </div>
            </b-col> -->
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12"
              style="padding: 8px; gap:10px; display: flex; justify-content: end;">
              <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind")
              }}</b-button>
              <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter")
              }}</b-button>
            </b-col>

          </b-row>

        </div>
      </b-form>
    </template>
    <template slot="table-body">
      <AccettazionePrenotazioniLazioListComponent ref="cmpAccettazioneSsnList" @openDetail="onOpenDetailRow"
        @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData" />
    </template>

  </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import AccettazionePrenotazioniLazioListComponent from "../components/AccettazionePrenotazioniLazioListComponent.vue";
import DatePicker from "vue2-datepicker";
export default {
  components: {
    DatePicker,
    SaPageLayout,
    AccettazionePrenotazioniLazioListComponent
  },
  mixins: { UtilityMixin },

  data() {
    return {
      pathResource: "/saccsarr",
      rows: 0,
      perPage: 20,
      page: 1,
      presidio: null,
      filtro: {
        cfPaziente: null,
        dataRiferimento: new Date().getTime(),
      },
      listKey: 0,
      showModalLoading: false,
      title: "Accettazione SSN",
      tipologiaRicettaOptions: [
        { text: "CONV", value: "CONVEZIONATO" },
        { text: "SSN", value: "SSN" },
        { text: "ROSSA", value: "ROSSA" },
        { text: "PRIVATA", value: "PRIVATA" },
        { text: "DEMATERIALIZZATA", value: "DEMATERIALIZZATA" },
      ],
    };
  },
  mounted() {

    /*this.getPresidio();
    if (this.presidio != null) {
      this.filtro.idPresidio = this.presidio.idPresidio;
    }
    this.loadUserData();*/



  },

  methods: {
    onOpenDetailRow() {
      let me = this;
      me.$refs.mdlAccettazioneSsn.show();
    },
    getPresidio() {
      let tmpPresidio = window.localStorage.getItem("presidio");
      if (tmpPresidio) {
        this.presidio = JSON.parse(tmpPresidio);
      }
    },
    onClickNuovaAccettazioneNRE() {
      this.$refs.mdlAccettazioneSsnAccettazioneNreModal.open();
    },
    onBeforeLoadData() {
      let me = this;
      me.showModalLoading = true;
    },
    onAfterLoadData() {
      let me = this;
      me.showModalLoading = false;
    },
    loadDataUtentiPresidio(id) {
      let me = this;
      UtilityMixin.methods.loadDataResources(me.pathResourcePresidi, { idUtente: id }, me.loadDataUtentiPresidiSuccess, me.loadDataUtentiPresidiError);
    },
    loadDataUtentiPresidiSuccess(response) {
      let me = this;
      me.presidiOptions = response.data.data.list;
      if (me.presidiOptions.length == 1) {
        me.filtro.idPresidio = me.presidiOptions[0].idPresidio;
      }
    },
    loadDataUtentiPresidiError(error) {
      console.log(error);
    },
    loadData() {
      let me = this;
      me.setFiltroSessionStorage(me.filtro);
      me.$refs.cmpAccettazioneSsnList.init();
    },
    submit() {
      let me = this;
      me.setFiltroSessionStorage(me.filtro);
      me.$refs.cmpAccettazioneSsnList.init();
    },
    onReset() {
      let me = this;
      me.filtro = {
        cfPaziente: null,
        dataRiferimento: new Date().getTime(),
      };
      me.setFiltroSessionStorage(me.filtro);
      me.$refs.cmpAccettazioneSsnList.init();
    },

    setFiltroSessionStorage(filtro) {
      let me = this;
      me.filtro.page = me.page;
      me.filtro.forPage = me.perPage;
      sessionStorage.setItem("filtroPagePrenotazioniLazio", JSON.stringify(filtro));
    },


  },
};
</script>

<style scoped>
::v-deep .sa-ft-date-input {
  cursor: pointer;
  height: 20px !important;
  line-height: 20px !important;
}

::v-deep .sa-ft-date-input::-webkit-calendar-picker-indicator {
  opacity: 0.5;
  cursor: pointer;
}

::v-deep .sa-ft-date-input {
  border: none;
  background: transparent;
  font-size: 0.85rem !important;
  font-weight: 600 !important;
  color: #1e293b;
  outline: none;
  padding: 0;
  width: 100%;
  font-family: inherit;
  cursor: pointer;
  appearance: none;
  /* Rimuove stili nativi su alcuni browser */
}

::v-deep .mx-datepicker,
.mx-datepicker {
  width: 100% !important;
}

::v-deep .mx-input,
.mx-input {
  /* RESET TOTALE */
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;

  /* ALLINEAMENTO */
  padding: 0 !important;
  margin: 0 !important;
  height: 40px !important;
  /* Forza l'altezza bassa */
  min-height: 22px !important;

  /* TESTO COERENTE */
  font-weight: 600 !important;
  color: #333 !important;
  border-bottom: 1px solid #cbd5e1 !important;
  border-bottom-left-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
  line-height: 1.2 !important;
}

/* Rimuove l'alone azzurro quando ci clicchi sopra */
::v-deep .mx-input:focus,
.mx-input:focus {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

/* Sistema l'icona interna del componente */
::v-deep .mx-icon-calendar,
.mx-icon-calendar {
  font-size: 14px;
  right: 5px;
  color: #94a3b8;
}
</style>
